import { useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../../Hooks/Hooks';
import { RootState } from '../../../Redux/Store';
import { submitFeedback } from '../../../Redux/Reducers/GlobalSlice';
import { DeviceInfoDataRender } from '../../../Utils/DeviceInfo';
import { arrayToObject, removeHtmlTags } from '../../../Utils/Basic';
import { EVENT, SCREEN } from '../../../Constants/AnalyticsConstants';
import { fbLogEvent } from '../../../Helpers/FirebaseHelper';
import { TFeedbackComponentProps } from './FeedbackComponent.type';
import './FeedbackComponent.scss';

const FeedbackMaxLength = 2000;
const FeedbackComponent = (props: TFeedbackComponentProps) => {
  const dispatch = useAppDispatch();
  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const [textAreaValue, setTextAreaValue] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e?.target;
    if (value.trim().length <= FeedbackMaxLength) {
      setTextAreaValue(value);
    } else {
      setTextAreaValue(value.slice(0, FeedbackMaxLength));
    }
  };
  const handleSubmit = () => {
    const deviceInformation = arrayToObject(DeviceInfoDataRender());
    if (textAreaValue) {
      const payload = {
        applicationName: 'FPO',
        deviceInfo: {
          vendor: deviceInformation?.vendor,
          platform: deviceInformation?.platform,
          osName: deviceInformation?.os_name,
          osVersion: deviceInformation?.os_version,
          browserName: deviceInformation?.browser_name,
          browserVersion: deviceInformation?.browser_version,
        },
        feedbackMessage: [
          {
            [removeHtmlTags(contentStackData?.feedback_content?.[0]?.content)]: textAreaValue,
          },
        ],
      };
      const callback = (msg: string) => {
        setTextAreaValue('');
        msg && toast(msg);
      };
      fbLogEvent(EVENT.UE_FEEDBACK_SUBMIT, {
        screen: SCREEN.FEEDBACK_MODAL,
        lead: SCREEN.FEEDBACK_MODAL,
      });
      dispatch(submitFeedback({ payload, callback }));
    }
  };

  return (
    <div className="FeedbackComponent">
      <div className="FeedbackComponent_Header">Feedback</div>
      {contentStackData?.feedback_content?.[0]?.content && (
        <>
          <div className="FeedbackComponent_Body">
            <p
              className="FeedbackComponent_Body_Label"
              dangerouslySetInnerHTML={{
                __html: contentStackData?.feedback_content?.[0]?.content,
              }}
            />

            <textarea
              placeholder="Enter your comments"
              rows={5}
              value={textAreaValue}
              onChange={handleChange}
            />
            <p className="FeedbackComponent_Body_Count">
              {textAreaValue?.trim().length}/{FeedbackMaxLength}
            </p>
          </div>
          <div className="FeedbackComponent_Footer">
            <button className="primary-cta-btn" onClick={handleSubmit} disabled={!textAreaValue}>
              Submit
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default FeedbackComponent;
